module.exports = fox._r("fonts/mc-icons-liveshow.svg", __webpack_public_path__ + "_/_/_/_/common/liveshow/fonts/mc-icons-liveshow.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/fonts/mc-icons-liveshow.svg
// module id = 190
// module chunks = 4